import cx from "classnames";
import { useTranslation } from "react-i18next";

import { ExclamationCircleIcon } from "@/components/icons/exclamation-circle";

type FormControlProps = {
  id: string;
  label: React.ReactNode;
  error?: string;
  required?: boolean;
  className?: string;
  hideLabel?: boolean;
  children?: React.ReactNode;
  requiredText?: string;
  labelClassName?: string;
};

export const FormControl = ({
  id,
  label,
  error,
  required,
  className,
  hideLabel,
  children,
  requiredText,
  labelClassName,
}: FormControlProps) => {
  const { t } = useTranslation();
  return (
    <div className={className}>
      <label
        htmlFor={id}
        className={cx(
          "mb-1 block text-xs font-medium text-gray-700",
          labelClassName,
          {
            "sr-only": hideLabel,
          }
        )}
      >
        {label}{" "}
        {required && (
          <span className="text-gray-600">
            {requiredText || `(${t("common.required")})`}
          </span>
        )}
      </label>
      {children}
      {error && (
        <div
          id={`${id}-error`}
          className="mt-1 flex items-center font-inter text-xs text-red-500"
        >
          <ExclamationCircleIcon className="mr-2" />
          {error}
        </div>
      )}
    </div>
  );
};
